module.exports = __webpack_public_path__ + "img/6.d92af388.png";